module.exports = __webpack_public_path__ + "img/1-md.1df07947.jpg";